import { ArrowRight, Warehouse } from 'lucide-react'
import type { MovementConfig } from '@/config/movements'
import { cn } from '@/utils/cn'

export type MovementTypeCardProps = {
  movement: MovementConfig
  onClick: () => void
  className?: string
}

function FlowNode({ kind }: { kind: 'leap' | 'customer' }) {
  if (kind === 'leap') {
    return (
      <span className="rfid-flow-node rfid-flow-node--leap text-[11px] font-black">L</span>
    )
  }
  return (
    <span className="rfid-flow-node">
      <Warehouse size={18} strokeWidth={2} className="text-muted-foreground" />
    </span>
  )
}

export function MovementTypeCard({ movement, onClick, className }: MovementTypeCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn('rfid-movement-card w-full', className)}
    >
      <div className="mb-1 flex items-center gap-1.5">
        <FlowNode kind={movement.flowFrom} />
        <ArrowRight size={14} className="text-[var(--leap-brand)]" strokeWidth={2.5} />
        <FlowNode kind={movement.flowTo} />
      </div>
      <div className="text-[12.5px] font-extrabold leading-4 text-foreground line-clamp-2">
        {movement.title}
      </div>
      <div className="mt-0.5 text-[10px] font-bold text-muted-foreground">
        {movement.legacyName}
      </div>
      <div className="mt-0.5 text-[10px] font-medium leading-[13px] text-muted-foreground line-clamp-2">
        {movement.description}
      </div>
    </button>
  )
}
